import type { Metadata } from "next";
import Login from "@/Component/Auth/Login";

export const metadata: Metadata = {
    title: "Login | Connector Club",
    description: "",
};

const LoginPage = () => {
    return (
        <Login role="user" />
    )
}

export default LoginPage
